import { render, staticRenderFns } from "./SearchInputDark.vue?vue&type=template&id=459054c4&scoped=true&"
import script from "./SearchInputDark.vue?vue&type=script&lang=js&"
export * from "./SearchInputDark.vue?vue&type=script&lang=js&"
import style0 from "./SearchInputDark.vue?vue&type=style&index=0&id=459054c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459054c4",
  null
  
)

export default component.exports